import React from 'react'

function About() {


    return (
        <div>
            <h1>This is the about page</h1>
        </div>
    )
}

export default About